import { connect } from 'react-redux';
import { TooltippedIcon } from '@mews-commander/ui';
import { IconName } from '@optimus-web/core';
import { LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { ApplicationState } from '@mews-commander/types';
import { Reservation } from '@mews-commander/data-access';
import { getResourceCategoryName } from '@mews-commander/legacy-entities/src/ducks/resourceCategories';

type OwnProps = Pick<Reservation, 'serviceId' | 'requestedCategoryId'>;
interface StateProps {
    resourceCategoryName?: string;
}

export const UpgradedResourceCategoryIcon = ({ resourceCategoryName = '' }: StateProps) => (
    <TooltippedIcon
        value={IconName.Upgraded}
        tooltip={
            <LocalizedText textKey={TextKey.ResourceCategoryUpgradedFrom} substitutes={{ resourceCategoryName }} />
        }
    />
);

export default connect<StateProps, null, OwnProps, ApplicationState>((state, { requestedCategoryId, serviceId }) => ({
    resourceCategoryName: getResourceCategoryName(state, { id: requestedCategoryId, serviceId }),
}))(UpgradedResourceCategoryIcon);
